import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppConfig } from '../models/app-config';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(private readonly http: HttpClient) { }

  private appConfig: AppConfig = {} as AppConfig;

  loadConfig(configName: string = "app.local") {

    return firstValueFrom(
    this.http.get<AppConfig>(`assets/config/${configName}.json`))
    .then((data) => {
      this.appConfig = data;
    });
  }

  get config(): Readonly<AppConfig> {
    return this.appConfig;
  }
}
